module.exports = __webpack_public_path__ + "img/p1.74b78baa.jpg";